import {getSearchCookie} from './cookies';

const defaultValues = {
    departureDate: null,
    arrivalDate: null,
    children: 0,
    adults: 1,
    petIncluded: false
};

export function getDatesFromCookie(cookie) {
    const {arrival, departure} = cookie;

    const arrivalMs = Date.parse(arrival);
    const departureMs = Date.parse(departure);

    const todayMs = Date.parse(new Date().toISOString().split('T')[0]);

    if (arrival && departure && arrivalMs >= todayMs && arrivalMs < departureMs) {
        return {
            arrivalDate: arrival,
            departureDate: departure
        };
    }

    return {
        arrivalDate: defaultValues.arrivalDate,
        departureDate: defaultValues.departureDate
    };
}

export function getTypeOfGuestFromCookie(cookieGuests, defaultNumber) {
    const guests = parseInt(cookieGuests, 10);

    if (isNaN(guests)) {
        return defaultNumber;
    }

    return guests;
}

export function getGuestsFromCookie(cookie) {
    const {
        children: defaultChildren,
        adults: defaultAdults,
        petIncluded: defaultPets
    } = defaultValues;

    const {numberOfAdults, numberOfChildren, petIncluded} = cookie;

    const adults = getTypeOfGuestFromCookie(numberOfAdults, defaultAdults);

    if (adults === 0) {
        return {
            adults: defaultAdults,
            children: defaultChildren,
            petIncluded: defaultPets
        };
    }

    const children = getTypeOfGuestFromCookie(numberOfChildren, defaultChildren);

    return {
        adults,
        children,
        petIncluded: typeof petIncluded === 'string' ? petIncluded === 'true' : petIncluded
    };
}

export function getSearchValues(cookies) {
    const cookie = getSearchCookie(cookies);

    if (!cookie) {
        return defaultValues;
    }

    return {
        ...getDatesFromCookie(cookie),
        ...getGuestsFromCookie(cookie)
    };
}
